module.exports = __webpack_public_path__ + "static/media/PDF_78.406bb497.pdf";